// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 621) return "static/chunks/621.b7a5b203e3a53776.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"19":"68d0b7feaa66b9f5","548":"dd1a39fac2e3a863"}[chunkId] + ".js";
};